import { defaultTo, find } from 'lodash';
import * as React from 'react';
import { RenderLeafProps } from 'slate-react';

import { setDefaults } from '../../../../slatePlugins/common/utils/setDefaults';
import { DEFAULT_TEXT_COLOR, MARK_TEXT_COLOR } from './defaults';
import { TextColorLeafProps, TextColorMarkPluginOptions } from './types';
import { colorsV2 } from '../../../colors-v2';

export const renderLeafTextColor =
  (options: TextColorMarkPluginOptions) =>
  ({ children, leaf }: RenderLeafProps) => {
    if (leaf[MARK_TEXT_COLOR] && !!leaf.text) {
      const { colorKey } = leaf[MARK_TEXT_COLOR] as TextColorLeafProps;
      const { colors, defaultColor } = setDefaults(options, DEFAULT_TEXT_COLOR.textColor);
      const color = defaultTo(
        find(colors, (cl) => cl.key === colorKey),
        defaultColor
      );

      const finalColor = colorsV2?.[colorKey] || (colorKey ? colorKey : defaultColor);

      return (
        <span
          data-color-key={colorKey}
          className="slate-text-color"
          style={{ color: finalColor }}
          color={color.color}
        >
          {children}
        </span>
      );
    }
    return children;
  };

export const renderLeafTextColorReadOnly =
  (options: TextColorMarkPluginOptions) =>
  ({ children, leaf }: RenderLeafProps) => {
    if (leaf[MARK_TEXT_COLOR] && !!leaf.text) {
      const { colorKey } = leaf[MARK_TEXT_COLOR] as TextColorLeafProps;
      const { colors, defaultColor } = setDefaults(options, DEFAULT_TEXT_COLOR.textColor);
      const color = defaultTo(
        find(colors, (cl) => cl.key === colorKey),
        defaultColor
      );
      return <span style={{ color: color.color }}>{children}</span>;
    }
    return children;
  };
